import { render } from "./AddFundTab.vue?vue&type=template&id=2d160547&scoped=true"
import script from "./AddFundTab.vue?vue&type=script&lang=js"
export * from "./AddFundTab.vue?vue&type=script&lang=js"

import "./AddFundTab.vue?vue&type=style&index=0&id=2d160547&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d160547"]])

export default __exports__